// extracted by mini-css-extract-plugin
export var contentWrapper = "ThankYou-module--contentWrapper--6c9bf";
export var media = "ThankYou-module--media--45914";
export var wrapper = "ThankYou-module--wrapper--0b89b";